const isInViewport = function (elem) {
  let distance = elem.getBoundingClientRect();
  return (
    distance.top >= 0 &&
    distance.left >= 0 &&
    distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    distance.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

function counter(element, start, end, duration) {
  let obj = element,
    current = start,
    range = end - start,
    increment = end > start ? 1 : -1,
    step = Math.abs(Math.floor(duration / range)),
    timer = setInterval(() => {
      current += increment;
      obj.textContent = current;
      if (current == end) {
        clearInterval(timer);
      }
    }, step);
}

let findMe = document.querySelector('.counter');

function startAniIncrement() {

  if (isInViewport(findMe)) {

    let counters = document.querySelectorAll('.counter');
    for (let element of counters) {
      let numero = element.getAttribute('data-count');
      let start = element.textContent;
      if (start == 0) {
        counter(element, 0, numero, 3000);
      }
    }

  } else {
    //console.log('Nope...');
  }
}

window.addEventListener('scroll', function (event) {
  if (!!findMe) {
    startAniIncrement();
  }
}, false);

window.onload = evt => {
  if (!!findMe) {
    startAniIncrement();
  }
};
